<div class="form-group-planetun" [formGroup]="formGroup">
    <label [for]="id">{{title}}</label>
    <textarea id="{{ id }}" rows="5" [disabled] autocomplete="off" [maxlength]="length" [value]="value ? value : ''" [readonly]="readonly" 
    [name]="name" [formControlName]="controlName" 
    [placeholder] ="placeholder"></textarea>
    <app-error-field [control]="formControl"></app-error-field>
</div>